import { Theme } from '@mui/material';
import { CommonComponents } from '../types';

export function getPrivatePickersMonth(theme: Theme): CommonComponents {
  return {
    styleOverrides: {
      root: {
        '&&': {
          fontSize: 14,
          borderRadius: theme.shape.borderRadiusSm,
        },
      },
    },
  };
}
